<template>
  <div class="app-personal-data-wrapper">
    <div v-if="showSuccess" class="change-success">
      <slot name="txtSuccess"></slot>
    </div>
    <slot name="txtBefore"></slot>
    <ChangePersonalDataForm
      :current-customer.sync="currentCustomer"
      :email-repeat.sync="emailRepeat"
      :invalid.sync="invalid"
      :activate-phone="false"
      :mail-success-message="mailSuccessMessage"
      :mail-link="mailLink"
      :mail-show-forced="mailShowForced"
    >
      <template v-for="slot in possibleChildSlotsFor('Change')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ChangePersonalDataForm>
    <Stepper
      @next="save()"
      :show-prev="false"
      :disabled-next="invalid"
      :loading-next="loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
    <slot name="txtAfter"></slot>
  </div>
</template>
<script>
import transaction from '@/mixins/transaction'
import ChangePersonalDataForm from '@/components/process/generic/PersonalData/ChangePersonalDataForm.vue'
import slotProxy from '../../../../../mixins/slotProxy'
import Stepper from '@/components/generic/Stepper.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'PersonalDataWrapper',
  data () {
    return {
      currentCustomer: {
        salutation: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        alternativePhone: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          supplement: '',
          zip: ''
        },
        email: ''
      },
      emailRepeat: '',
      invalid: true,
      loading: false
    }
  },
  mixins: [
    transaction('personalData'),
    slotProxy()
  ],
  methods: {
    ...mapActions('personalData', [
      'changePersonalData'
    ]),
    ...mapGetters('personalData', [
      'getView'
    ]),
    ...mapMutations('personalData', [
      'changeView'
    ]),
    setEmailRepeat (data) {
      this.emailRepeat = data.email
    },
    save () {
      this.loading = true
      this.changePersonalData(this.currentCustomer).then(() => {
        this.loading = false
      }, () => {
        this.loading = false
      })
    }
  },
  computed: {
    showView () {
      return this.getView() === 'viewPersonalData'
    },
    showSuccess () {
      return this.getView() === 'personalDataChangeSuccess'
    }
  },
  created: function () {
    this.changeView('viewPersonalData')
  },
  components: {
    ChangePersonalDataForm,
    Stepper
  },
  props: {
    mailSuccessMessage: {
      type: Boolean,
      default: false
    },
    mailLink: {
      type: String,
      required: true
    },
    mailShowForced: {
      type: Boolean,
      default: false
    }
  },
  apollo: {
    currentCustomer: function () {
      const me = this
      return wrapQuery(
        gql`query personalData {
          currentCustomer {
            salutation,
            firstName,
            birthDate,
            lastName,
            alternativePhone,
            address {
              city,
              houseNumber,
              street,
              supplement,
              zip
            },
            email
          }
        }`, this, 'currentCustomer', {},
        function (data) {
          me.setEmailRepeat(data)
        }
      )
    }
  }
}
</script>
